import React from 'react';
import DownloadsListItemDownload from "./DownloadsListItemDownload";
import {DownloadItem} from "../types/downloadItem";

type DownloadsListProps = {
    downloadItem : DownloadItem
}

function DownloadsListItem({downloadItem} : DownloadsListProps) {

    const itemTypeDownload = 'Internezzo.Downloads:Content.Download';
    const itemTypeOrder = 'Internezzo.Downloads:Content.Product';
    const itemTypeLink = 'Internezzo.Downloads:Content.Link';

    return (
        <div className="downloadsOverview__list--item">
            <div className={`downloadsOverview__list--item-title ${downloadItem.type === itemTypeDownload ? 'type-download' : downloadItem.type === itemTypeOrder ? 'type-product' : downloadItem.type === itemTypeLink ? 'type-link' : ''}`}>
               <span>{downloadItem.name}</span>
            </div>

            <div className="downloadsOverview__list--item-price">
                <span>{downloadItem.price}</span>
            </div>

            <DownloadsListItemDownload downloadItem={downloadItem} />
        </div>
    );
}

export default DownloadsListItem;
